export default __webpack_public_path__ + "static/media/codeofconduct.084885d5.pdf";